<hvac-link class='hvac-content-card'  [link]="cardContent.link" [linkType]="cardLinkType">
    <div class='hvac-content-card-top-container'>
        <img *ngIf="cardContent.imgSrc" class='hvac-content-card-image'  [src]="cardContent.imgSrc"/>
        <h3 class='hvac-content-card-header' [innerHTML]="cardContent.title | richText"></h3>
        <utc-svg class='hvac-content-card-header-link-icon' [ngClass]="{'external-link': cardLinkType === 'href'}"
            [src]="'assets/icons/arrow.svg'"></utc-svg>
    </div>
    <span *ngIf="cardContent.body" class='hvac-content-card-body' [innerHTML]="cardContent.body | richText | textOverflow:maxBodyLength"></span>
</hvac-link>
